var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "protocol_detail_list_area"
  }, [_c('h2', {
    staticClass: "list_tit"
  }, [_vm._v("목차")]), _c('ul', {
    staticClass: "protocol_detail_list"
  }, _vm._l(_vm.indexList, function (item, index) {
    return _c('li', {
      class: {
        active: _vm.selected.index == index && _vm.scrollMode
      },
      on: {
        "click": function ($event) {
          return _vm.indexSelect(item, index);
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.setTitleName(index, item))
      }
    })]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }